namespace RedBullMOBILE360.SpecialEvent {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.SpecialEvent.SpecialEventDialog')
    export class SpecialEventDialog extends Serenity.EntityDialog<SpecialEventRow, any> {
        protected getFormKey() { return SpecialEventForm.formKey; }
        protected getIdProperty() { return SpecialEventRow.idProperty; }
        protected getLocalTextPrefix() { return SpecialEventRow.localTextPrefix; }
        protected getNameProperty() { return SpecialEventRow.nameProperty; }
        protected getService() { return SpecialEventService.baseUrl; }
        protected getDeletePermission() { return SpecialEventRow.deletePermission; }
        protected getInsertPermission() { return SpecialEventRow.insertPermission; }
        protected getUpdatePermission() { return SpecialEventRow.updatePermission; }

        protected form = new SpecialEventForm(this.idPrefix);
    }
}